import React, { Component, Fragment } from 'react';
import { Radio, Checkbox } from 'antd';
import * as Func from '../../../../../helpers/functions';
import {
    checkUndefine,
    multipleValidate,
    formatValidation,
    capitalizeFirstLetter,
    vietnameseStringToUnicode,
    formatMoney,
} from '../../../../../helpers/functions';
import {
    FormWrapperInputComponent,
    DatePickerComponent,
} from "../../../common/component/Index";
import { CURRENCY, PAYMENT_GATEWAY, ALL_CURRENCY_ENUM, DATE_TIME_FORMAT } from '../../../../../constants/Define';

import Modal from '../../../common/component/Modal';
import Input from '../../../common/component/Input';
import Wrapper from '../../../common/component/Wrapper';
import TextArea from '../../../common/component/TextArea';
import Span from '../../../common/component/Span';
import AntSelect, { AntOption } from '../../../common/component/AntSelect';

import { cloneDeep, find } from 'lodash';
import { Tooltip } from 'antd'
import { getLocaleFullName } from '../../../../../utils/commonUtils';

import DEFINE from "../../../../../constants/Define";
import moment from 'moment';
import * as OrderService from '../../../../../services/orderService';
import './OrderAccessTrade.less';

const initState = {
    exportData: {
        startDate: moment.utc().startOf('months'),
        endDate: moment.utc().endOf('days'),
        affiliateSource: undefined,
    },
    validation: {},
    affiliateSources: [],
    isFetchingAffiliateSources: false,
}

export default class OrderAccessTrade extends Component {
    constructor(props) {
        super(props);
        this.state = cloneDeep(initState);
    }

    componentDidMount() {
        if (this.props.visible) {
            this.loadAffiliateSources();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && prevProps.visible !== this.props.visible) {
            this.loadAffiliateSources();
        }
    }

    render() {
        const { t, visible, orderState, } = this.props;
        const { validation, exportData, affiliateSources, isFetchingAffiliateSources } = this.state;

        return (
            <Modal className="order-access-trade"
                destroyOnClose={true}
                visible={visible}
                title={t(`item.order.exportAccessTrade`)}
                onOk={this.onSubmit} okText={t(`action.export`)}
                onCancel={this.props.onCancel} cancelText={t(`action.cancel`)}
            >
                <Wrapper className="m-0 p-0">
                    <FormWrapperInputComponent
                        isRequired={true}
                        isValidation={true}
                        dataValidation={exportData.startDate}
                        validation={validation.startDate}
                        labelTitle={t(`item.order.exportDate`)}
                    >
                        <DatePickerComponent className={`form-control applyDates w100-percent`}
                            disabledDate={this.disabledPublishDate}
                            hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.SHORT_DATE}
                            style={{ padding: 0, border: 0 }}
                            onChange={this.onChangeDate} name={`applyDates`}
                            placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                            value={[exportData.startDate, exportData.endDate]}
                        />
                    </FormWrapperInputComponent>
                    <FormWrapperInputComponent
                        dataValidation={exportData.affiliateSource}
                        validation={validation.affiliateSource}
                        labelTitle={t(`item.order.affiliateSource`)}
                    >
                        <AntSelect className="select-types w100-percent"
                            showArrow
                            showSearch
                            loading={isFetchingAffiliateSources}
                            placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.order.affiliateSource")).toLowerCase())}
                            value={exportData.affiliateSource}
                            onChange={this.onChangeAffiliateSource}
                            style={{ width: '100%' }}
                            filterOption={(input, option) => (option.props.children || '').toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            {(affiliateSources || []).map(source => (
                                <AntOption key={source} value={source}>{source}</AntOption>
                            ))}
                        </AntSelect>
                    </FormWrapperInputComponent>
                </Wrapper>
            </Modal>
        )
    }

    onSubmit = () => {
        if (this.validate()) {
            const { startDate: rawStartDate, endDate: rawEndDate, affiliateSource } = this.state.exportData;
            const startDate = rawStartDate.toISOString();
            const endDate = rawEndDate.toISOString();
            this.props.exportAccessTrade({ startDate, endDate, ...(affiliateSource ? { affiliateSource } : {}) });
            this.props.onSubmit(this.state.exportData)
        }
    }

    onChangeDate = (dateRange) => {
        if (dateRange.fullValue) {
            this.setState({
                exportData: {
                    ...this.state.exportData,
                    startDate: dateRange.fullValue[0],
                    endDate: dateRange.fullValue[1]
                }
            })
        }
    }

    onChangeAffiliateSource = (affiliateSource) => {
        this.setState({
            exportData: {
                ...this.state.exportData,
                affiliateSource,
            }
        })
    }

    loadAffiliateSources = () => {
        const { affiliateSources, isFetchingAffiliateSources } = this.state;
        if (isFetchingAffiliateSources || affiliateSources.length) {
            return;
        }

        this.setState({ isFetchingAffiliateSources: true });
        OrderService.getAffiliateSources()
            .then(result => {
                this.setState({
                    affiliateSources: result || [],
                    isFetchingAffiliateSources: false,
                });
            })
            .catch(() => {
                this.setState({ isFetchingAffiliateSources: false });
            });
    }

    validate() {
        const { t } = this.props;
        const { exportData } = this.state;
        let validate = {
            required: {
                startDate: formatValidation(t('validation.statusCode.code.1'), t(`item.order.exportDate`)),
                endDate: formatValidation(t('validation.statusCode.code.1'), t(`item.order.exportDate`)),
            },
        };
        let valueValidate = {
        };
        const result = multipleValidate(exportData, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    disabledPublishDate = (current) => {
        return current && current > moment().endOf('days');
    }

}

OrderAccessTrade.defaultProps = {
    onCancel: () => { },
    onSubmit: () => { },
}
